import type {
  CreateCustomFormArg,
  CreateCustomFormResponse,
  DeleteCustomFormPathArg,
  DeleteCustomFormResponse,
  DuplicateCustomFormArg,
  DuplicateCustomFormResponse,
  ReadCustomFormArg,
  ReadCustomFormResponse,
  ReadCustomFormsArg,
  ReadCustomFormsResponse,
  ReadFormSubmissionArg,
  ReadFormSubmissionResponse,
  UpdateCustomFormArg,
  UpdateCustomFormResponse,
} from 'lib-shared-types-api';

import { api } from 'app/app.api';

const formTag = 'MessengerForm';

export const customFormsApi = api
  .enhanceEndpoints({ addTagTypes: [formTag] })
  .injectEndpoints({
    endpoints: (builder) => ({
      readForm: builder.query<ReadCustomFormResponse, ReadCustomFormArg>({
        query: ({ form_id, version }) => ({
          version: 1,
          path: `custom-fields/forms/${form_id}`,
          params: version ? { version } : undefined,
        }),
      }),

      readForms: builder.query<ReadCustomFormsResponse, ReadCustomFormsArg>({
        query: () => ({ version: 1, path: `forms` }),
        providesTags: [formTag],
      }),

      createForm: builder.mutation<
        CreateCustomFormResponse,
        CreateCustomFormArg
      >({
        query: (payload) => ({
          version: 1,
          path: `custom-fields/forms`,
          method: 'POST',
          body: {
            label: payload.label,
            description: payload.description,
            submit_button_label: payload.submitButtonLabel,
            submit_success_message: payload.submitSuccessMessage,
          },
        }),
        invalidatesTags: [formTag],
      }),

      deleteForm: builder.mutation<
        DeleteCustomFormResponse,
        DeleteCustomFormPathArg
      >({
        query: ({ form_id }) => ({
          version: 1,
          path: `custom-fields/forms/${form_id}`,
          method: 'DELETE',
        }),
        invalidatesTags: [formTag],
      }),

      updateForm: builder.mutation<
        UpdateCustomFormResponse,
        UpdateCustomFormArg
      >({
        query: (payload) => ({
          version: 1,
          path: `custom-fields/forms/${payload.id}`,
          method: 'PUT',
          body: payload,
        }),
        invalidatesTags: [formTag],
      }),

      duplicateForm: builder.mutation<
        DuplicateCustomFormResponse,
        DuplicateCustomFormArg
      >({
        query: ({ form_id, identifier, description, label }) => ({
          version: 1,
          path: `custom-fields/forms/${form_id}/duplicate`,
          method: 'POST',
          body: {
            label,
            description,
            identifier_suffix: identifier,
          },
        }),
        invalidatesTags: [formTag],
      }),

      readFormSubmissionData: builder.query<
        ReadFormSubmissionResponse,
        ReadFormSubmissionArg
      >({
        query: ({ form_id, form_version, submission_id }) => ({
          version: 1,
          path: `custom-fields/forms/${form_id}/versions/${form_version}/submissions/${submission_id}`,
        }),
      }),
    }),
  });
